var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddGuest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#008CFF",
    strokeLinecap: "round",
    d: "M4 21v-2.802a3.923 3.923 0 013.923-3.923h5.378a3.923 3.923 0 013.923 3.923V21h0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.612,
    cy: 8.67,
    stroke: "#008CFF",
    strokeLinecap: "round",
    rx: 3.306,
    ry: 3.363
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008CFF",
    d: "M21.311 7.552h-1.954V9.67h-1.152V7.552h-1.944V6.5h1.944V4.387h1.152V6.5h1.954z"
  }))));
}
export default SvgAddGuest;